var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.826 0.899643C16.194 0.610958 15.4909 0.499769 14.7967 0.578745C14.1026 0.657721 13.4454 0.923685 12.8999 1.34633L3.83979 8.57921L3.59108 8.83692V2.27406C3.59108 1.81841 3.40391 1.38143 3.07076 1.05924C2.7376 0.737044 2.28574 0.556038 1.81458 0.556038C1.34343 0.556038 0.891568 0.737044 0.55841 1.05924C0.225252 1.38143 0.0380859 1.81841 0.0380859 2.27406V19.4543C0.0380859 19.91 0.225252 20.3469 0.55841 20.6691C0.891568 20.9913 1.34343 21.1723 1.81458 21.1723C2.28574 21.1723 2.7376 20.9913 3.07076 20.6691C3.40391 20.3469 3.59108 19.91 3.59108 19.4543V12.8915L3.83979 13.1492L12.8999 20.382C13.553 20.8942 14.3685 21.1733 15.2094 21.1723C15.7672 21.1692 16.3181 21.0521 16.826 20.8287C17.3752 20.5946 17.8432 20.2125 18.1739 19.7281C18.5047 19.2437 18.6843 18.6775 18.6913 18.0971V3.6313C18.6843 3.05086 18.5047 2.48463 18.1739 2.00024C17.8432 1.51585 17.3752 1.13377 16.826 0.899643ZM15.1383 17.7363L6.57559 10.8642L15.1383 4.14671V17.7363Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackback);
export default __webpack_public_path__ + "static/media/backback.59819dab5a52c4266e965d260bcbaccc.svg";
export { ForwardRef as ReactComponent };